"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToastMessage = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _index = require("../../svg/index");

var _useGlobalStyles = require("../../styles/global/useGlobalStyles");

var _toastMessage = require("./toastMessage.style");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var ToastMessage = function ToastMessage(props) {
  (0, _useGlobalStyles.useGlobalStyles)();
  var classes = (0, _toastMessage.useStyles)(props);
  var type = props.type,
      children = props.children;
  var toastE = (0, _react.useRef)(null);

  var setIcon = function setIcon() {
    switch (type) {
      case "warning":
        return _index.warning;

      case "error":
        return _index.error;

      case "information":
        return _index.information;

      case "success":
        return _index.success;
    }
  };

  var title = function title() {
    switch (type) {
      case "warning":
        return "هشدار";

      case "error":
        return "خطا";

      case "information":
        return "اطلاعات";

      case "success":
        return "موفق";
    }
  };

  var icon = setIcon();

  var hidden = function hidden() {
    toastE.current.className += " ".concat(classes.hidden);
  };

  return /*#__PURE__*/_react["default"].createElement("div", {
    ref: toastE,
    className: "".concat(classes.toastBox, " ").concat(classes.show)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(classes.badge)
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "".concat(classes.badgeIcon)
  }, icon)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(classes.toastContent)
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "".concat(classes.toastContentType)
  }, title()), /*#__PURE__*/_react["default"].createElement("p", {
    className: "".concat(classes.toastContentText)
  }, children)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(classes.toastAction),
    onClick: function onClick() {
      return hidden();
    }
  }, _index.close));
};

exports.ToastMessage = ToastMessage;
ToastMessage.propTypes = {
  /** ToastMessage type */
  type: _propTypes["default"].oneOf(["warning", "error", "information", "success"]),

  /** ToastMessage text */
  children: _propTypes["default"].node.isRequired
};
ToastMessage.defaultProps = {
  type: "success"
};